import { Alert, Typography } from "antd";

const { Text } = Typography;

type Warning = {
  type: string;
  message: string;
  transaction_id?: string;
};

interface Props {
  warnings: Warning[];
}
const groupWarningsByType = (
  warnings: Warning[],
): Record<string, Warning[]> => {
  return warnings.reduce<Record<string, Warning[]>>((acc, warning) => {
    if (!acc[warning.type]) {
      acc[warning.type] = [];
    }
    acc[warning.type].push(warning);
    return acc;
  }, {});
};
export function WarningsAlert({ warnings }: Props) {
  const grouped = groupWarningsByType(warnings);

  const description = (
    <>
      {Object.entries(grouped).map(([type, list]) => {
        if (list.length === 1) {
          return (
            <div key={type} className="mb-2">
              {list[0].message}
              {list[0].transaction_id && (
                <>
                  {" "}
                  (transaction:{" "}
                  <Text code copyable>
                    {list[0].transaction_id}
                  </Text>
                  )
                </>
              )}
            </div>
          );
        } else {
          return (
            <div key={type} className="mb-2">
              <div>
                There are {list.length} warnings of type "
                <strong>{type}</strong>"
              </div>
              <ul className="ml-4">
                {list.map((w, i) => (
                  <li key={i}>
                    {w.message}
                    {w.transaction_id && (
                      <>
                        {" "}
                        (transaction:{" "}
                        <Text code copyable>
                          {w.transaction_id}
                        </Text>
                        )
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          );
        }
      })}
    </>
  );

  return (
    <Alert
      message="Warnings"
      description={description}
      type="warning"
      showIcon
      className="mb-4"
    />
  );
}
